import React from "react";
import { Page, PageTitle } from "components/ui/Page";
import { LargeSpacer } from "components/ui/VerticalSpacers";
import { DelegateWelcomeCard } from "../cards/DelegateWelcomeCard";
import { PageColumn, EvenThirdsLayout } from "components/ui/PageColumns";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+Delegate+Welcome+Page
export function DelegateWelcomePage() {
  return (
    <Page>
      <PageTitle title="Welcome" />
      <LargeSpacer />
      <EvenThirdsLayout>
        <PageColumn>
          <DelegateWelcomeCard />
        </PageColumn>
      </EvenThirdsLayout>
    </Page>
  );
}
